import { BrowserView, MobileView } from 'react-device-detect';
import { Link } from 'react-router-dom'
import { Nav } from 'react-bootstrap'
import { Dispatch, SetStateAction } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const LoginLogoutComponent 
  : React.FC<{setExpanded: Dispatch<SetStateAction<boolean>>}> 
  = (props) => {

    const { setExpanded } = props
    
    const {
        isAuthenticated,
        loginWithRedirect,
        logout,
      } = useAuth0();

    return (
        <>
            <BrowserView>
              {!isAuthenticated ?
                <Link type='button' className='btn btn-outline-light mx-3' to='/login' onClick={() => {loginWithRedirect(); setExpanded(false)}}>Zaloguj</Link>
                :
                <button className='btn btn-outline-light mx-3' onClick={async () => logout({
                    logoutParams: {
                        returnTo: window.location.origin
                    }
                })}>Wyloguj</button>
              }
            </BrowserView>
            <MobileView>
              {!isAuthenticated ?
                <Nav.Link as={Link} to='/login' onClick={() => {loginWithRedirect(); setExpanded(true)}}>Zaloguj</Nav.Link>
                :
                <Nav.Link as={Link} to='/login' onClick={async () => {
                    logout({
                        logoutParams: {
                            returnTo: window.location.origin
                        }
                    });
                    setExpanded(false)
                }}>Wyloguj</Nav.Link>
              }
            </MobileView> 
        </>
    )
}